const nearley = require("nearley");
const grammar = require("../grammars/expression.js");

const builtins = {
  COUNT: (value) => {
    return value.length;
  },
  SUM: (value1, value2) => {
    return value1 + value2;
  },
  KEY: (value, key) => {
    return value.map((x) => x[key]);
  },
  OCCURENCE: (value, key) => {
    const unique = {};
    const keyUnique = {};
    for (const elem of value) {
      if (!keyUnique[elem[key]]) {
        keyUnique[elem[key]] = true;
        unique[elem[key]] = 1;
      } else {
        unique[elem[key]] += 1;
      }
    }
    return Object.values(unique);
  },
  AVG: (value) => {
    if (value.length < 0) return 0;
    var total = 0;
    for (const elem of value) {
      total += elem;
    }
    return parseFloat(total / value.length).toFixed(2);
  },
  FILTER: (value, filters) => {
    return value.filter((x) => {
      for (const filter of JSON.parse(filters)) {
        switch (filter.filter) {
          case "EQUALS":
          case "EQUAL":
            if (x[filter.source] !== filter.value) return false;
            break;
          case "NOT EQUAL":
          case "NOT EQUALS":
            if (x[filter.source] === filter.value) return false;
            break;
          case "SUPERIOR":
            if (x[filter.source] <= filter.value) return false;
            break;
          case "SUPERIOR OR EQUAL":
          case "SUPERIOR OR EQUALS":
            if (x[filter.source] < filter.value) return false;
            break;
          case "INFERIOR":
            if (x[filter.source] >= filter.value) return false;
            break;
          case "INFERIOR OR EQUAL":
          case "INFERIOR OR EQUALS":
            if (x[filter.source] >= filter.value) return false;
            break;
          case "IN":
            if (!filter.value.includes(x[filter.source])) return false;
            break;
          case "NOT IN":
            if (filter.value.includes(x[filter.source])) return false;
            break;
          case "EMPTY":
            if (filter.source.length !== 0) return false;
            break;
          case "NOT EMPTY":
            if (filter.source.length === 0) return false;
            break;
          case "EXIST":
          case "EXISTS":
            if (!filter.source) return false;
            break;
          case "NOT EXIST":
          case "NOT EXISTS":
            if (filter.source) return false;
            break;
          case "CONTAIN":
          case "CONTAINS":
            if (!x[filter.source].includes(filter.value)) return false;
            break;
          case "NOT CONTAIN":
          case "NOT CONTAINS":
            if (x[filter.source].includes(filter.value)) return false;
            break;
        }
      }
      return true;
    });
  },
  UNIQUE: (value, key) => {
    const unique = [];
    const keyUnique = {};
    for (const elem of value) {
      if (!keyUnique[elem[key]]) {
        keyUnique[elem[key]] = true;
        unique.push(elem);
      }
    }
    return unique;
  },
  PERCENT: (value, amount, round = 0) =>
    parseFloat(((value / amount) * 100).toFixed(round)),
  TIME: {
    NOW: () => {
      let today = new Date();
      today.setDate(1);
      today.setMonth(0);
      today.setYear(2000);
      return today;
    },
    SUB: {
      HOUR: (date, nbr) => {
        date = new Date(date);
        today.setDate(1);
        today.setMonth(0);
        today.setYear(2000);
        date.setHours(date.getHours() - nbr);
        return date;
      },
      MIN: (date, nbr) => {
        date = new Date(date);
        today.setDate(1);
        today.setMonth(0);
        today.setYear(2000);
        date.setMinutes(date.getMinutes() - nbr);
        return date;
      },
    },
    ADD: {
      HOUR: (date, nbr) => {
        date = new Date(date);
        today.setDate(1);
        today.setMonth(0);
        today.setYear(2000);
        date.setHours(date.getHours() + nbr);
        return date;
      },
      MIN: (date, nbr) => {
        date = new Date(date);
        today.setDate(1);
        today.setMonth(0);
        today.setYear(2000);
        date.setMinutes(date.getMinutes() + nbr);
        return date;
      },
    },
  },
  DATE: {
    SUB: {
      DAY: (date, nbr) => {
        date = new Date(date);
        date.setSeconds(0);
        date.setMinutes(0);
        date.setHours(12);
        date.setMilliseconds(0);
        date.setDate(date.getDate() - nbr);
        return date;
      },
      MONTH: (date, nbr) => {
        date = new Date(date);
        date.setSeconds(0);
        date.setMinutes(0);
        date.setHours(12);
        date.setMilliseconds(0);
        date.setMonth(date.getMonth() - nbr);
        return date;
      },
      YEAR: (date, nbr) => {
        date = new Date(date);
        date.setSeconds(0);
        date.setMinutes(0);
        date.setHours(12);
        date.setMilliseconds(0);
        date.setYear(date.getFullYear() - nbr);
        return date;
      },
    },
    ADD: {
      DAY: (date, nbr) => {
        date = new Date(date);
        date.setSeconds(0);
        date.setMinutes(0);
        date.setHours(12);
        date.setMilliseconds(0);
        date.setDate(date.getDate() + nbr);
        return date;
      },
      MONTH: (date, nbr) => {
        date = new Date(date);
        date.setSeconds(0);
        date.setMinutes(0);
        date.setHours(12);
        date.setMilliseconds(0);
        date.setMonth(date.getMonth() + nbr);
        return date;
      },
      YEAR: (date, nbr) => {
        date = new Date(date);
        date.setSeconds(0);
        date.setMinutes(0);
        date.setHours(12);
        date.setMilliseconds(0);
        date.setYear(date.getFullYear() + nbr);
        return date;
      },
    },
    DIFF: (start, end) => {
      start = new Date(start);
      date.setSeconds(0);
      date.setMinutes(0);
      date.setHours(12);
      date.setMilliseconds(0);
      end = new Date(end);
      end.setSeconds(0);
      end.setMinutes(0);
      end.setHours(12);
      end.setMilliseconds(0);
      var diff = start.getTime() - end.getTime();
      return Math.round(diff / (1000 * 60 * 60 * 24));
    },
    NOW: () => {
      let today = new Date();
      today.setSeconds(0);
      today.setMinutes(0);
      today.setHours(12);
      today.setMilliseconds(0);
      return today;
    },
  },
  DATETIME: {
    SUB: {
      DAY: (date, nbr) => {
        date = new Date(date);
        date.setDate(date.getDate() - nbr);
        return date;
      },
      MONTH: (date, nbr) => {
        date = new Date(date);
        date.setMonth(date.getMonth() - nbr);
        return date;
      },
      YEAR: (date, nbr) => {
        date = new Date(date);
        date.setYear(date.getFullYear() - nbr);
        return date;
      },
      HOUR: (date, nbr) => {
        date = new Date(date);
        date.setHours(date.getHours() - nbr);
        return date;
      },
      MIN: (date, nbr) => {
        date = new Date(date);
        date.setMinutes(date.getMinutes() - nbr);
        return date;
      },
    },
    ADD: {
      DAY: (date, nbr) => {
        date = new Date(date);
        date.setDate(date.getDate() + nbr);
        return date;
      },
      MONTH: (date, nbr) => {
        date = new Date(date);
        date.setMonth(date.getMonth() + nbr);
        return date;
      },
      YEAR: (date, nbr) => {
        date = new Date(date);
        date.setYear(date.getFullYear() + nbr);
        return date;
      },
      HOUR: (date, nbr) => {
        date = new Date(date);
        date.setHours(date.getHours() + nbr);
        return date;
      },
      MIN: (date, nbr) => {
        date = new Date(date);
        date.setMinutes(date.getMinutes() + nbr);
        return date;
      },
    },
    NOW: () => {
      let today = new Date();
      return today;
    },
  },
};

function fetchPath(object, path) {
  for (let value of path.value) {
    if (typeof value === "object") value = value.value;
    if (typeof object !== "object") throw new Error(`Invalid path supplied`);
    object = object[value];
  }

  return object;
}

function evalExpr(expression, config = {}, depth = 0) {
  if (typeof expression === "string") {
    const parser = new nearley.Parser(nearley.Grammar.fromCompiled(grammar));
    parser.feed(expression);
    return evalExpr(parser.results[0], config, depth).value;
  } else {
    const env = config.env ?? {};
    const { type, ...rest } = expression;
    switch (type) {
      case "cond":
        const cond = evalExpr(expression.condition, config, depth + 1);
        if (cond.value === true)
          return evalExpr(expression.true, config, depth + 1);
        else return evalExpr(expression.false, config, depth + 1);
      case "path":
        if (expression.value.length === 1) {
          const pkw = expression.value[0].value;

          switch (pkw) {
            case "true":
            case "false":
              return { type: "boolean", value: pkw === "true" };
          }
        }
        return { type: "any", value: fetchPath(env, expression) };
      case "func":
        const funcs = { ...builtins, ...config.functions };
        const fn = fetchPath(funcs, rest.name);
        const args = rest.args.map((expr) => {
          const { value } = evalExpr(expr, config, depth + 1);
          return value;
        });
        return { type: "any", value: fn.apply(null, args) };
      default:
        return expression;
    }
  }
}

module.exports = evalExpr;
